var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "0 0 480 480",
    width: "480pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m216 136c-17.671875 0-32 14.328125-32 32v16h64v-16c0-17.671875-14.328125-32-32-32zm0 0",
    fill: "#ff9811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m440 136h-224c17.671875 0 32 14.328125 32 32v304h224v-304c0-17.671875-14.328125-32-32-32zm0 0",
    fill: "#ffdaaa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m120 8v144c0 17.671875 14.328125 32 32 32h32v-16c0-17.671875 14.328125-32 32-32h128v-128zm0 0",
    fill: "#ffc477"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24 184h176c8.835938 0 16 7.164062 16 16v256c0 8.835938-7.164062 16-16 16h-176c-8.835938 0-16-7.164062-16-16v-256c0-8.835938 7.164062-16 16-16zm0 0",
    fill: "#ed1c24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m40 216h144v48h-144zm0 0",
    fill: "#7ed63e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffcd00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 296h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 296h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 296h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 352h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 352h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 352h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 408h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 408h32v32h-32zm0 0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m248 336v136h152c-84 0-152-60.800781-152-136zm0 0",
    fill: "#ffc477"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m8 336v120c0 8.835938 7.164062 16 16 16h136c-84 0-152-60.800781-152-136zm0 0",
    fill: "#cd2a00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m40 408h32v32h-32zm0 0",
    fill: "#ffcd00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m32 272h160v-64h-160zm16-48h128v32h-128zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m32 336h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m88 336h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m144 336h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m32 392h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m88 392h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m144 392h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m32 448h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m88 448h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m144 448h48v-48h-48zm16-32h16v16h-16zm0 0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m440 128h-88v-128h-240v152c.03125 8.683594 2.914062 17.117188 8.207031 24h-96.207031c-13.253906 0-24 10.746094-24 24v256c0 13.253906 10.746094 24 24 24h176c13.253906 0 24-10.746094 24-24v-256c-.027344-2.730469-.523438-5.4375-1.472656-8h17.472656v288h240v-312c-.027344-22.082031-17.917969-39.972656-40-40zm-312 24v-136h208v112h-120c-22.082031.027344-39.972656 17.917969-40 40v8h-24c-13.253906 0-24-10.746094-24-24zm112 16v8h-48v-8c0-13.253906 10.746094-24 24-24s24 10.746094 24 24zm-32 32v256c0 4.417969-3.582031 8-8 8h-176c-4.417969 0-8-3.582031-8-8v-256c0-4.417969 3.582031-8 8-8h176c4.417969 0 8 3.582031 8 8zm256 264h-208v-296c-.03125-8.683594-2.914062-17.117188-8.207031-24h192.207031c13.253906 0 24 10.746094 24 24zm0 0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m176 112h16v-8c8.835938 0 16-7.164062 16-16v-8c0-8.835938-7.164062-16-16-16h-16v-8h32v-16h-16v-8h-16v8c-8.835938 0-16 7.164062-16 16v8c0 8.835938 7.164062 16 16 16h16v8h-32v16h16zm0 0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m224 40h16v16h-16zm0 0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m256 40h48v16h-48zm0 0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m224 64h16v16h-16zm0 0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m256 64h48v16h-48zm0 0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m224 88h16v16h-16zm0 0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m256 88h48v16h-48zm0 0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m320 368h-16v8c-8.835938 0-16 7.164062-16 16v8c0 8.835938 7.164062 16 16 16h16v8h-32v16h16v8h16v-8c8.835938 0 16-7.164062 16-16v-8c0-8.835938-7.164062-16-16-16h-16v-8h32v-16h-16zm0 0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m352 376h16v16h-16zm0 0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m384 376h48v16h-48zm0 0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m352 400h16v16h-16zm0 0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m384 400h48v16h-48zm0 0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m352 424h16v16h-16zm0 0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m384 424h48v16h-48zm0 0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m288 168h16v16h-16zm0 0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m320 168h112v16h-112zm0 0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m288 200h16v16h-16zm0 0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m320 200h112v16h-112zm0 0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m288 232h16v16h-16zm0 0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m320 232h112v16h-112zm0 0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m288 264h16v16h-16zm0 0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m320 264h112v16h-112zm0 0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m288 296h16v16h-16zm0 0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m320 296h112v16h-112zm0 0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m288 328h16v16h-16zm0 0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m320 328h112v16h-112zm0 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.52cd35cafb16f07a52ba23efe435bbbd.svg";
export { ForwardRef as ReactComponent };